/* eslint-disable import/prefer-default-export */
export const global = {
  data() {
    return {
      site: process.env.VUE_APP_SITE
    };
  }
};
